import { buttons, siteConfig } from "./constants";

function changeToList(dom) {
  if (!dom) {
    return;
  }

  if (!dom.classList.contains(buttons.listClass)) {
    dom.classList.add(buttons.listClass);
  }
}

function changeToGrid(dom) {
  if (dom.classList.contains(buttons.listClass)) {
    dom.classList.remove(buttons.listClass);
  }
}

function getViewContainer() {
  return document.querySelector(buttons.viewContainer);
}

function updateActiveButton(activetedButton) {
  document.querySelector(".btn-options.active").classList.remove("active");
  activetedButton.classList.add("active");
}

function updatePaginationUl(classNameAdded, classNameRemoved) {
  const ulPaginationElement = document.querySelector(
    ".view-products ul.pagination"
  );

  if (!ulPaginationElement) {
    return;
  }

  ulPaginationElement.classList.add(classNameAdded);
  ulPaginationElement.classList.remove(classNameRemoved);
}

function searchView() {
  if (document.getElementById("searchInput") === null) return;

  const myCollapsible = document.getElementById("searchInput");
  myCollapsible.addEventListener("show.bs.collapse", function() {
    const container = document.querySelector(".container-filter-buttons");
    container.classList.add("visualy-hidden");
  });
  myCollapsible.addEventListener("hidden.bs.collapse", function() {
    const container = document.querySelector(".container-filter-buttons");
    container.classList.remove("visualy-hidden");
  });
}

export default function addListeners() {
  document.querySelectorAll(buttons.btnOptionsGrid).forEach(dom => {
    dom.addEventListener("click", () => {
      changeToGrid(getViewContainer());
      updateActiveButton(dom);
      updatePaginationUl("grid", "list");
      localStorage.setItem(siteConfig.storageView, "grid");
    });
  });

  document.querySelectorAll(buttons.btnOptionsList).forEach(dom => {
    dom.addEventListener("click", () => {
      changeToList(getViewContainer());
      updateActiveButton(dom);
      updatePaginationUl("list", "grid");
      localStorage.setItem(siteConfig.storageView, "list");
    });
  });
  searchView();
}
